var map = {
	"./ad.svg": 54322,
	"./ae.svg": 26290,
	"./af.svg": 85381,
	"./ag.svg": 33053,
	"./ai.svg": 93925,
	"./al.svg": 1115,
	"./am.svg": 55834,
	"./ao.svg": 55196,
	"./ar.svg": 46554,
	"./as.svg": 57522,
	"./at.svg": 28041,
	"./au.svg": 79557,
	"./aw.svg": 60837,
	"./az.svg": 74614,
	"./ba.svg": 95236,
	"./bb.svg": 26981,
	"./bd.svg": 20102,
	"./be.svg": 38361,
	"./bf.svg": 37363,
	"./bg.svg": 45003,
	"./bh.svg": 28848,
	"./bi.svg": 95974,
	"./bj.svg": 75824,
	"./bm.svg": 34822,
	"./bo.svg": 23162,
	"./br.svg": 46618,
	"./bs.svg": 54738,
	"./bt.svg": 92323,
	"./bw.svg": 61911,
	"./by.svg": 99319,
	"./bz.svg": 43792,
	"./ca.svg": 84477,
	"./cd.svg": 95449,
	"./cf.svg": 73589,
	"./cg.svg": 24515,
	"./ch.svg": 32371,
	"./ci.svg": 36797,
	"./ck.svg": 99343,
	"./cl.svg": 50846,
	"./cm.svg": 70259,
	"./cn.svg": 56341,
	"./co.svg": 21419,
	"./cr.svg": 81664,
	"./cu.svg": 38750,
	"./cv.svg": 30951,
	"./cw.svg": 68766,
	"./cy.svg": 56449,
	"./cz.svg": 37542,
	"./de.svg": 39598,
	"./dj.svg": 37483,
	"./dk.svg": 73230,
	"./dm.svg": 90595,
	"./do.svg": 28026,
	"./dz.svg": 74569,
	"./ec.svg": 42726,
	"./ee.svg": 40800,
	"./eg.svg": 24747,
	"./er.svg": 77060,
	"./es.svg": 82236,
	"./et.svg": 50025,
	"./fi.svg": 50681,
	"./fj.svg": 92656,
	"./fk.svg": 7725,
	"./fm.svg": 43597,
	"./fo.svg": 88646,
	"./fr.svg": 83715,
	"./ga.svg": 63875,
	"./gb.svg": 64243,
	"./gd.svg": 63489,
	"./ge.svg": 15077,
	"./gg.svg": 91199,
	"./gh.svg": 42350,
	"./gi.svg": 87507,
	"./gl.svg": 40694,
	"./gm.svg": 8398,
	"./gn.svg": 46926,
	"./gq.svg": 93567,
	"./gr.svg": 98568,
	"./gt.svg": 48003,
	"./gu.svg": 57445,
	"./gw.svg": 3339,
	"./hk.svg": 84616,
	"./hn.svg": 68630,
	"./hr.svg": 51935,
	"./ht.svg": 29997,
	"./hu.svg": 18965,
	"./id.svg": 42464,
	"./ie.svg": 28125,
	"./il.svg": 41365,
	"./im.svg": 1672,
	"./in.svg": 71958,
	"./io.svg": 74650,
	"./iq.svg": 63079,
	"./ir.svg": 93738,
	"./is.svg": 12128,
	"./it.svg": 71306,
	"./je.svg": 38061,
	"./jm.svg": 6819,
	"./jo.svg": 58959,
	"./jp.svg": 59262,
	"./ke.svg": 94369,
	"./kg.svg": 21753,
	"./kh.svg": 64694,
	"./ki.svg": 87950,
	"./km.svg": 1956,
	"./kn.svg": 10689,
	"./kp.svg": 19229,
	"./kr.svg": 37107,
	"./kw.svg": 89550,
	"./ky.svg": 4329,
	"./kz.svg": 2794,
	"./la.svg": 2860,
	"./lb.svg": 32186,
	"./li.svg": 36556,
	"./lk.svg": 90594,
	"./lr.svg": 94892,
	"./ls.svg": 36692,
	"./lt.svg": 23132,
	"./lu.svg": 5217,
	"./lv.svg": 50040,
	"./ly.svg": 15345,
	"./ma.svg": 96641,
	"./mc.svg": 53445,
	"./md.svg": 29516,
	"./me.svg": 34755,
	"./mg.svg": 69289,
	"./mh.svg": 52154,
	"./mk.svg": 31649,
	"./ml.svg": 28461,
	"./mm.svg": 87974,
	"./mn.svg": 77409,
	"./mo.svg": 13969,
	"./mp.svg": 57427,
	"./mq.svg": 69228,
	"./mr.svg": 4027,
	"./ms.svg": 57183,
	"./mt.svg": 31804,
	"./mu.svg": 29345,
	"./mv.svg": 23398,
	"./mw.svg": 84063,
	"./mx.svg": 94301,
	"./my.svg": 7230,
	"./mz.svg": 97601,
	"./na.svg": 62313,
	"./nato.svg": 94107,
	"./ne.svg": 97043,
	"./nf.svg": 1501,
	"./ng.svg": 38429,
	"./ni.svg": 83719,
	"./nl.svg": 57456,
	"./no.svg": 52412,
	"./np.svg": 11052,
	"./nr.svg": 33890,
	"./nu.svg": 2048,
	"./nz.svg": 71058,
	"./om.svg": 13591,
	"./pa.svg": 45306,
	"./pe.svg": 63703,
	"./pf.svg": 11649,
	"./pg.svg": 56075,
	"./ph.svg": 88040,
	"./pk.svg": 58932,
	"./pl.svg": 10275,
	"./pn.svg": 90243,
	"./pr.svg": 47764,
	"./ps.svg": 28086,
	"./pt.svg": 89302,
	"./pw.svg": 5377,
	"./py.svg": 15452,
	"./qa.svg": 24064,
	"./ro.svg": 54103,
	"./rs.svg": 35983,
	"./ru.svg": 80510,
	"./rw.svg": 46833,
	"./sa.svg": 90907,
	"./sb.svg": 16681,
	"./sc.svg": 62469,
	"./sd.svg": 56983,
	"./se.svg": 35553,
	"./sg.svg": 14544,
	"./si.svg": 80759,
	"./sk.svg": 79700,
	"./sl.svg": 5614,
	"./sm.svg": 75263,
	"./sn.svg": 56563,
	"./so.svg": 28487,
	"./sr.svg": 69972,
	"./ss.svg": 69240,
	"./st.svg": 30828,
	"./sv.svg": 66830,
	"./sx.svg": 36421,
	"./sy.svg": 80354,
	"./sz.svg": 82936,
	"./tc.svg": 35092,
	"./td.svg": 59476,
	"./tg.svg": 19302,
	"./th.svg": 90981,
	"./tibet.svg": 61757,
	"./tj.svg": 31766,
	"./tk.svg": 47357,
	"./tm.svg": 93908,
	"./tn.svg": 18897,
	"./to.svg": 92982,
	"./tr.svg": 1839,
	"./tt.svg": 23809,
	"./tv.svg": 43103,
	"./tw.svg": 76207,
	"./tz.svg": 46472,
	"./ua.svg": 68718,
	"./ug.svg": 6887,
	"./us.svg": 1509,
	"./uy.svg": 51810,
	"./uz.svg": 13193,
	"./ve.svg": 54935,
	"./vi.svg": 31328,
	"./vn.svg": 24280,
	"./vu.svg": 16634,
	"./ws.svg": 99287,
	"./ye.svg": 69713,
	"./za.svg": 42608,
	"./zm.svg": 45400,
	"./zw.svg": 62174
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58795;